export enum StatiPratica {
  Draft = 1,
  Sent = 2,
  NeedsReview = 3,
  Approved = 4,
  Rejected = 5,
  Completed = 6,
}

export enum AVAILABLE_BONUSES {
  Eco = 1,
  Mobili,
}

export const BONUS_LABELS = {
  1: "Condizionatori",
  2: "Elettrodomestici",
};

export type Pratica = {
  id: string | number;
  d_i: string;
  d_m: string;
  content?: string;
  correzioni?: string;
  beneficiario: string;
  status: StatiPratica;
  importo: number;
  user: {
    id: string | number;
    email: string;
    name: string;
  };
  condominio?: number;
  figli?: number[];
  id_padre?: number;
  ceduta?: number;
  ceduta_file: string;
  barcode?: string;
  asseveratore?: number;
  ade_caricata?: number;
  ade_firmata?: number;
  foto_caricate: number;
  ceduta_ricevuta: string;
  data_ricezione?: string | null;
  tipo_bonus?: AVAILABLE_BONUSES;
};

export type Log = {
  id: number;
  id_utente: number;
  data_inserimento: string;
  jsondata: string;
  name: string;
  status: number;
  tx: string;
};

type StatusColor = {
  text: string;
  bg: string;
};
type StatusDisplay = {
  color: StatusColor;
  desc: string;
};
type StatusDisplayObj = {
  [key: number]: StatusDisplay;
};

export type UserData = {
  id: number;
  id_commercialista?: number;
  approved_budget?: number;
  budget_history?: string;
  tipo_persona?: number;
  name?: string;
  cf?: string;
  email?: string;
  indirizzo?: string;
  cod_destinatario?: string;
  pec?: string;
  tel?: string;
  rap_leg_nome?: string;
  rap_leg_cf?: string;
  rap_leg_email?: string;
  rap_leg_cel?: string;
  ci_fronte?: string;
  ci_retro?: string;
  cf_fronte?: string;
  cf_retro?: string;
  visura?: string;
  status?: number;
  d_i?: string;
  d_m?: string;
  totale_pratiche?: number;
};

// Installatore
export const StatusPraticaAgent: StatusDisplayObj = {
  1: {
    color: {
      text: "text-gray-800",
      bg: "bg-gray-100",
    },
    desc: "1/5 Bozza",
  },
  2: {
    color: {
      text: "text-yellow-800",
      bg: "bg-yellow-100",
    },
    desc: "2/5 Inviata per verifica",
  },
  3: {
    color: {
      text: "text-red-800",
      bg: "bg-red-100",
    },
    desc: "2/5 Richieste modifiche",
  },
  4: {
    color: {
      text: "text-green-800",
      bg: "bg-green-100",
    },
    desc: "3/5 Approvata",
  },
  5: {
    color: {
      text: "text-red-800",
      bg: "bg-red-100",
    },
    desc: "Rifiutata",
  },
  6: {
    color: {
      text: "text-indigo-800",
      bg: "bg-indigo-100",
    },
    desc: "5/5 Conclusa",
  },

  8: {
    color: {
      text: "text-red-800",
      bg: "bg-red-100",
    },
    desc: "Annullata",
  },
};

// Commercialista
export const StatusPraticaOperator: StatusDisplayObj = {
  1: {
    color: {
      text: "text-gray-800",
      bg: "bg-gray-100",
    },
    desc: "Bozza",
  },
  2: {
    color: {
      text: "text-yellow-800",
      bg: "bg-yellow-100",
    },
    desc: "2/5 da verificare",
  },
  3: {
    color: {
      text: "text-red-800",
      bg: "bg-red-100",
    },
    desc: "2/5 In attesa di correzione",
  },
  4: {
    color: {
      text: "text-green-800",
      bg: "bg-green-100",
    },
    desc: "3/5 Approvata",
  },
  5: {
    color: {
      text: "text-red-800",
      bg: "bg-red-100",
    },
    desc: "Rifiutata",
  },
  6: {
    color: {
      text: "text-indigo-800",
      bg: "bg-indigo-100",
    },
    desc: "5/5 Conclusa",
  },

  8: {
    color: {
      text: "text-red-800",
      bg: "bg-red-100",
    },
    desc: "Annullata",
  },
};
